/**
 * Dropdown module.
 * @module Dropdown
 */

$('.dropdown--keep-open .dropdown-menu').on('click', (event) => {
  event.stopPropagation();
});

$('.tab-content .dropdown--keep-open .dropdown-menu').each(function () {
  const dropdownToggle = $(this).prev('.dropdown-toggle');
  const checkedCount = $(this).find('input:checkbox').filter(':checked').length;

  if (checkedCount !== 0) {
    dropdownToggle.addClass('filtered');
  }
});

$('.dropdown').each(function () {
  const dropdown = $(this);
  getCheckedElms2Str();
  function getCheckedElms2Str() {
    if (dropdown.find('input:checked').length >= 1) {
      // found checked, value to array
      const selectedItems = dropdown
        .find('input:checked')
        .map(function () {
          return $(this).parent().find('.checkbox-custom-label').text();
        })
        .toArray();
      // join array 2 str
      const selectedElementsStr = selectedItems.join(',');
      // apply 2
      dropdown.find('.dropdown-toggle > span:first-child').text(selectedElementsStr);
    }
  }
});

$('.dropdown--multichecked').each(function () {
  const dropdown = $(this);

  const defaultTextfield = dropdown.find('.dropdown-toggle > span:first-child');
  const dropdownInitialWidth = defaultTextfield.width();

  const ddDefaultTxt = dropdown.find('.dropdown-toggle > span:first-child').text();

  const selection = dropdown.parents('.col-xs-12').find('.dataTable');

  // Set Label on change
  dropdown.find('input:checkbox').on('change', updateLabel);

  // Set Selection on change
  selection.find('input:checkbox').on('change', updateSelection);

  // Set Label on page initialisation
  if ($('.col-xs-12 .dataTable').find('input:checked').length >= 1) {
    selection.on('load', updateSelection);
    dropdown.on('load', updateLabel);
  }

  function updateSelection() {
    // const thisSelection = selection.val();

    const selectedItems = selection
      .find('input:checked')
      .map(function () {
        return $(this).val();
      })
      .toArray();

    let selectedItemsStr = ddDefaultTxt;

    selectedItems.forEach((item) => {
      checkedItem = dropdown.find('ul input[value="' + item + '"]');
      checkedItem.prop('checked', true);
    });

    const labelText = checkedItem.next('.checkbox-custom-label').text();
    const valNotAllChecked = dropdown.find('ul input:checked').not('input[value="all"]');
    const valNotAll = dropdown.find('ul input').not('input[value="all"]');

    if ($(this).is(':checked') !== true) {
      const thisSelectItemVal = $(this).val();
      dropdown.find('ul input[value="' + thisSelectItemVal + '"]').prop('checked', false);
    }

    if (dropdown.find('ul input:checked').length === 1) {
      selectedItemsStr = labelText;
    } else if (valNotAllChecked.length > 1 && valNotAllChecked.length !== valNotAll.length) {
      selectedItemsStr = ddDefaultTxt + ' (' + dropdown.find('ul input:checked').length + ')';
      dropdown.find('input:checkbox[value="all"]').prop('checked', false);
    } else if (valNotAllChecked.length === valNotAll.length) {
      dropdown.find('input:checkbox[value="all"]').prop('checked', true);
      selectedItemsStr = dropdown.find('input:checkbox[value="all"]').next('.checkbox-custom-label').text();
      dropdown.find('.dropdown-toggle > span:first-child').text(selectedItemsStr);
    } else if (selectedItems.length === 0) {
      dropdown.find('input:checkbox').prop('checked', false);
    }

    dropdown.find('.dropdown-toggle > span:first-child').text(selectedItemsStr);
  }

  function updateLabel() {
    const thisCheckbox = $(this);
    const thisLabel = $(this).val();
    // const initalWith = $(this).width();

    function setLabel() {
      const selectedElements = dropdown
        .find('ul input:checked')
        .map(function () {
          return $(this).siblings('.checkbox-custom-label').text();
        })
        .toArray();

      let selectedElementsStr = ddDefaultTxt;
      const checkBox = $('.col-xs-12').find('.dataTable input:checkbox[value="' + thisLabel + '"]');

      if (thisCheckbox.prop('checked') === true) {
        checkBox.prop('checked', true);
      } else {
        checkBox.prop('checked', false);
      }

      if (selectedElements.length === 1) {
        selectedElementsStr = selectedElements.join(',');
        defaultTextfield.removeClass('truncate-block').width('auto');
      } else if (selectedElements.length > 1) {
        // selectedElementsStr = ddDefaultTxt + ' (' + selectedElements.length + ')';
        selectedElementsStr = selectedElements.join(',');
        defaultTextfield.addClass('truncate-block').width(dropdownInitialWidth);
      } else if (selectedElements.length === 0) {
        $('.col-xs-12').find('.dataTable input:checkbox').prop('checked', false);
        defaultTextfield.removeClass('truncate-block').width('auto');
      }

      dropdown.find('.dropdown-toggle > span:first-child').text(selectedElementsStr);
    }

    if (!$(this).val() == 'all') {
      $('input:checkbox[value="all"]').prop('checked', false);

      setLabel();

      // NOT NECESSARY *BOPTGLMP-216
      // IT'S NECESSARY => ODSUPPORT-3452
      if (dropdown.find('input:checked').length - 1 === dropdown.find('input').not('input[value="all"]').length - 1) {
        dropdown.find('input:checkbox[value="all"]').prop('checked', true);
        const allLabelChecked = dropdown.find('input:checkbox[value="all"]').siblings('.checkbox-custom-label').text();
        dropdown.find('.dropdown-toggle > span:first-child').text(allLabelChecked);
      }
    } else {
      const selectorParent = $(this).parents('.col-xs-12').find('.dataTable');
      $(selectorParent).find('input:checkbox').prop('checked', this.checked);
      $(this).parents('.dropdown--multichecked').find('input:checkbox').prop('checked', this.checked);

      setLabel();

      if ($('input:checkbox[value="all"]').is(':checked')) {
        const thisLabelChecked = $(this).siblings('.checkbox-custom-label').text();
        dropdown.find('.dropdown-toggle > span:first-child').text(thisLabelChecked);
      } else {
        dropdown.find('.dropdown-toggle > span:first-child').text(ddDefaultTxt);
      }
    }
  }
});

$('.js-download-notification-enabled')
  .next()
  .find('li a.isrestricted')
  .add('.js-addBasketElements-notification-enabled.isrestricted')
  .on('click', function (event) {
    event.preventDefault();
    $('#js-download-notification').modal('show');
    const url = $(this).attr('href');
    $('#js-download-notification').find('.btn.accept').attr('href', url);
  });
